module.exports = "<div class=\"form-group\">\n    <h3>{{_.i18n('Dropbox API key')}}</h3>\n    <input class=\"form-control\" type=\"text\" name=\"dropboxKey\" value=\"{{dropboxKey}}\" placeholder=\"{{_.i18n(placeholder)}}\" />\n</div>\n\n<div class=\"form-group\">\n    <p>{{_.i18n('dropbox.api info 1')}} <a target=\"_blank\" href=\"https://www.dropbox.com/developers/apps\">Dropbox</a></p>\n    <p>{{_.i18n('dropbox.api info 2')}}</p>\n    <ol>\n        <li>{{_.i18n('dropbox.api info li 1')}}</li>\n        <li>{{_.i18n('dropbox.api info li 2')}}</li>\n    </ol>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/dropbox/settings/template.html
// module id = 1275
// module chunks = 0